const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTopoFinalizadas(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "master-artboard",
    viewBox: "0 0 1404.8455810546875 437.292236328125",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    style: {
      enableBackground: "new 0 0 1400 980"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.467519760131836, 0, 0, 4.467519760131836, -2781.3777099619456, 2.865672684724146)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.04179565608501435, 0, 0, 0.04179565608501435, -246.71034887522842, -345.74047851562506)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camada_x0020_1",
    transform: "matrix(1, 0, 0, 1, 86.95172493493737, 35.47159908068261)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_1962010478480",
    transform: "matrix(1, 0, 0, 1, 608.6620483398438, 6.487695081909806)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil0 finalizadas_hora  area_cor_cabecalho",
    d: "M20227.72 8739.19l0 0c0,192.58 156.1,348.64 348.68,348.64l1412.84 0c31.47,0 61.7,12.57 83.96,34.83l364.53 364.53 0 -740c0,-197.03 -159.71,-356.73 -356.73,-356.73l-1504.6 0c-192.58,0 -348.68,156.14 -348.68,348.73z",
    style: {
      fill: "rgb(134, 101, 170)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0 botao finalizadas_dia  area_cor_cabecalho",
    d: "M20227.72 9809.94l0 0c0,192.58 156.1,348.64 348.68,348.64l1412.84 0c31.47,0 61.7,12.57 83.96,34.83l364.53 364.53 0 -740c0,-197.03 -159.71,-356.73 -356.73,-356.73l-1504.6 0c-192.58,0 -348.68,156.14 -348.68,348.73z",
    style: {
      fill: "rgb(134, 101, 170)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 26877.689453125 10000.240234375 L 27487.240234375 9474.16015625 L 26877.689453125 8948.16015625 L 22509.140625 8948.16015625 L 22509.140625 10000.240234375 Z",
    className: "fil0  area_cor_cabecalho",
    style: {
      fill: "rgb(134, 101, 170)",
      fillRule: "nonzero"
    },
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 724.5976494035158, 0)"
  })))), /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 120,
    style: {
      fill: "white",
      fontSize: "54.01px",
      fontFamily: "'Arial'",
      color: "white"
    },
    className: "area_cor_fonte_cabecalho"
  }, "1 HORA:"), /*#__PURE__*/React.createElement("text", {
    x: 300,
    y: 125,
    style: {
      fill: "white",
      fontWeight: "bold",
      fontSize: "64.01px",
      fontFamily: "'Arial'",
      color: "white"
    },
    className: "label camada_finalizadas_hora finalizadas_hora area_cor_fonte_cabecalho"
  }, "0"), /*#__PURE__*/React.createElement("text", {
    x: 75,
    y: 325,
    style: {
      fill: "white",
      fontSize: "54.01px",
      fontFamily: "'Arial'",
      color: "white"
    },
    className: "area_cor_fonte_cabecalho"
  }, "1 DIA:"), /*#__PURE__*/React.createElement("text", {
    x: 250,
    y: 325,
    style: {
      fill: "white",
      fontWeight: "bold",
      fontSize: "64.01px",
      fontFamily: "'Arial'",
      color: "white"
    },
    className: "label camada_finalizadas_dia finalizadas_dia area_cor_fonte_cabecalho"
  }, "0"), /*#__PURE__*/React.createElement("text", {
    x: 515,
    y: 265,
    style: {
      fill: "rgb(218, 191, 255)",
      whiteSpace: "pre",
      color: "rgb(51, 51, 51)",
      fontSize: 85,
      fontWeight: "bold"
    },
    className: "area_cor_fonte_cabecalho"
  }, "FINALIZADAS"));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopoFinalizadas);
export default __webpack_public_path__ + "static/media/topo_finalizadas.95d652a383052c9038fc75335148412d.svg";
export { ForwardRef as ReactComponent };